import React from 'react';
import { useIntl } from 'react-intl';
import ResultCount from '../components/facets/count/ResultCount';
import SearchFiltersMulti from '../components/facets/filters/SearchFiltersMulti';
import Pagination from '../components/facets/pagination/Pagination';
import SortOrder from '../components/facets/sort';
import NoAvailableResult from '../../global/atoms/noAvailableResult';
import {
    categoryFacet,
    nameSortAsc,
    nameSortDesc,
    querySummaryProductResultsController,
    relevanceSortCriterion,
    rentalsPagerController,
    sortController
} from '../controllers/searchresultscontroller';
import '../plp/plp.scss';
import SRPProductListing from './SRPProductListing';
import ToggleSwitch from '../../global/atoms/ToggleSwitch/ToggleSwitch';
import { srpDataLocators } from './dataLocators';
import { useCapUtils } from '../../cap/hooks/useCapUtils';

const ProductResults = ({
    productState,
    queryState,
    setQueryState,
    facetsList,
    controllerConfig,
    showUnavailableItems,
    handleToggleChange,
    searchCount,
    searchQuery
}) => {
    const intl = useIntl();
    const { showToggleButton } = useCapUtils();
    const showUnavailableClickHandler = event => {
        event?.stopPropagation();
        handleToggleChange(false);
    };

    return (
        <div className="row">
            <div className="col-lg-3">
                <div className="plp__filter plp__left-filter">
                    <div className="plp__left-filterbutton">
                        <SearchFiltersMulti
                            title={'Filter'}
                            filterTitleClass={'plp__filter-title'}
                            filterBodyClasess={''}
                            facetControllerList={facetsList}
                            categoryFacet={categoryFacet}
                            controllerConfig={controllerConfig}
                            isCategoryFacetVisible={true}
                            triggerEvents={true}
                            presetFacet={null}
                            queryState={queryState}
                        />
                    </div>
                    <div className="plp__left-dropdown">
                        <SortOrder
                            controller={sortController}
                            nameSortAsc={nameSortAsc}
                            nameSortDesc={nameSortDesc}
                            relevanceSortCriterion={relevanceSortCriterion}
                        />
                    </div>
                </div>
            </div>
            <div className="col-lg-9" id="searchresultsection">
                <div className="plp__right-filter">
                    <div className="plp__right-filter-buttonselect">
                        <div className="plp__right-filter-mobile-filter">
                            <SortOrder
                                controller={sortController}
                                nameSortAsc={nameSortAsc}
                                nameSortDesc={nameSortDesc}
                                relevanceSortCriterion={relevanceSortCriterion}
                            />
                        </div>
                        {showToggleButton() && (
                            <div className="plp__right-filter-toggle">
                                <ToggleSwitch
                                    id={srpDataLocators.srp_toggle_switch}
                                    checked={showUnavailableItems}
                                    onChange={handleToggleChange}
                                    name={intl.formatMessage({ id: 'hide-unavailable-items' })}
                                />
                            </div>
                        )}
                    </div>

                    {searchCount > 0 && (
                        <ResultCount
                            controller={querySummaryProductResultsController}
                            queryState={queryState}
                            setQueryState={setQueryState}
                        />
                    )}
                </div>
                {searchCount > 0 ? (
                    <>
                        <SRPProductListing productState={productState} totalResults={queryState?.total} />
                        <div>
                            <Pagination controller={rentalsPagerController} />
                        </div>
                    </>
                ) : (
                    <NoAvailableResult
                        searchQuery={searchQuery}
                        onShowUnavailableClick={showUnavailableClickHandler}
                        dataTestid={srpDataLocators.srp_show_unavailable_products}
                        count={searchCount}
                    />
                )}
            </div>
        </div>
    );
};

export default React.memo(ProductResults);
